module.exports = __webpack_public_path__ + "img/farmstead-logo.8bb3daa4.png";